<template>
    <!--课程列表-->
    <div class="course content">
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="courseList"></Table>
        </div>
    </div>
</template>
<style scoped>
.accountAudit_top {
    width: 500px;
    display: inline-block;
}
</style>
<script>
import pageComponent from "../common/page.vue";
import http from "../../libs/http.js";
import { mapActions, mapGetters } from "vuex";
export default {
    components: {
        pageComponent
    },
    data() {
        return {
            loading: false,
            courseList: [],
            columns: [
                {
                    title: "课程分类",
                    key: "type",
                    align: "center",
                    render: (h, params) => {
                        // 根据 type 值设置标签文本和样式
                        const tagConfig = params.row.type === 1
                            ? { text: "体验课", type: "warning" }
                            : { text: "正式课", type: "success" };
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px"
                                }
                            },
                            [
                                // 使用 Tag 组件替代普通文本
                                h(
                                    "Tag",
                                    {
                                        props: {
                                            type: tagConfig.type,  // 设置标签类型（颜色）
                                            size: "medium",        // 标签大小
                                            effect: "light"        // 标签样式（亮色）
                                        },
                                        style: {
                                            marginRight: "15px",
                                            fontSize: "14px"
                                        }
                                    },
                                    tagConfig.text  // 标签显示的文本
                                ),
                            ]
                        );
                    }
                },
                {
                    title: "操作",
                    //                        width: 300,
                    key: "action",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px"
                                }
                            },
                            [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                            disabled:
                                                this.sectionStatus == 1
                                                    ? this.getLimit == 1 ||
                                                    this.getLimit == 6 ||
                                                    this.getLimit == 11
                                                        ? false
                                                        : true
                                                    : false,
                                        },
                                        style: {
                                            marginRight: "10px",
                                        },
                                        on: {
                                            click: () => {
                                                this.addCourse(params.row.type);
                                            },
                                        },
                                    },
                                    "课程管理"
                                ),
                            ]
                        );
                    }
                }
            ]
        };
    },
    created() {
        this.setRecord(null);
    },
    mounted() {
        this.getCourse();
    },
    methods: {
        //姓名搜索
        search() {
            this.getCourse();
        },
        ...mapActions(["setRecord"]),
        //获取课程列表
        getCourse() {
            this.courseList = [{
                type: 1,
                typeName: '体验课',
            },{
                type: 2,
                typeName: '正式课',
            }]
        },
        // 点击添加/编辑课程事件
        addCourse(type) {
            this.$router.push({
                path: "course",
                query: { type: type }
            });
        },
    },
    computed: {
        ...mapGetters(["getLimit"])
    }
};
</script>
